import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Cookie } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900 text-white p-4 shadow-lg" data-testid="cookie-banner">
      <div className="container mx-auto max-w-4xl flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Cookie className="h-5 w-5 text-amber-400 flex-shrink-0" />
          <p className="text-sm">
            We use cookies to improve your experience and analyze site traffic.
            By using ProjectStatusReport, you agree to our use of cookies.
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <Link 
            to="/privacy" 
            target="_blank"
            className="text-sm text-blue-400 hover:text-blue-300 underline"
          >
            Privacy Policy
          </Link>
          <Button 
            onClick={handleAccept}
            size="sm"
            className="bg-blue-600 hover:bg-blue-700"
            data-testid="cookie-accept-btn"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
